import { compose } from 'redux';
import { query, mutation, DOWNLOAD_REPORT } from './API';
import ProductiveCoverage from './ProductiveCoverage';
import withRequestTracker from '../../../utils/composition/withRequestTracker';

const composedProductiveCoverage = compose(DOWNLOAD_REPORT, withRequestTracker({ query, mutation }))(ProductiveCoverage);

export default composedProductiveCoverage;
